import PropTypes from 'prop-types';
import React from 'react';
import Badge, { BadgeVariants } from '../../../components/atoms/Badge';
import tableCss from '../../../components/organisms/Table.css';
import CellLoader from '../../../components/widgets/CellLoader';
import { MEMBER_GROUP_TYPES, RoleTypes } from '../../utils';
import css from './UserTypeCell.css';

const ROLE_TO_BADGE_VARIANT = {
    [RoleTypes.ADMIN]: BadgeVariants.ACTIVE,
    [RoleTypes.STANDARD]: BadgeVariants.SUCCESS,
    [RoleTypes.RESTRICTED]: BadgeVariants.WARNING,
};
const INACTIVE_COLOR = '#c1c1c1';

const UserTypeCell = ({ value, row, isLoading, loaderClass = '', className }) => {
    const isInactive = row?.groupName === MEMBER_GROUP_TYPES.inactive;
    const variant = isInactive ? BadgeVariants.TRANSPARENT : ROLE_TO_BADGE_VARIANT[value] || BadgeVariants.DARK;
    const color = isInactive ? INACTIVE_COLOR : undefined;

    return (
        <td className={className || tableCss.rowIndexCell}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : (
                value && (
                    <Badge variant={variant} color={color} className={css.badge}>
                        {value}
                    </Badge>
                )
            )}
        </td>
    );
};

UserTypeCell.propTypes = {
    value: PropTypes.string,
    row: PropTypes.shape({
        groupName: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    loaderClass: PropTypes.string,
    className: PropTypes.string,
};

export default UserTypeCell;
